import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = [ "form", "sendButton"];
  connect() {
    this.bindFormEvents();
    this.bindChangeEvents();
  }

  bindFormEvents () {
    this.formTarget.addEventListener('submit', function (e) {
      let isValid = this._validateForm();
      if (!isValid) {
        this.sendButtonTarget.disabled = true
        e.preventDefault();
      }
    }.bind(this))
  }

  bindChangeEvents() {
    this.formTarget.addEventListener('input', function (e) {
      if (e.target.value != "") {
        this._removeFeedbackDivs(e);
      }
    }.bind(this))
  }

  _removeFeedbackDivs(e) {
    e.target.classList.remove('is-invalid-file')
    this.sendButtonTarget.disabled = false
    let missingField = document.getElementById(`${e.target.id}_required`);
    let invalidField = document.getElementById(`${e.target.id}_invalid`);
    if (invalidField)  invalidField.style.display = 'none';
    if (missingField) missingField.style.display = 'none';
  }

  _validateForm() {
    let validFields = this._checkValidFields();
    let requiredFields = this._checkRequiredFields();
    return validFields && requiredFields;
  }

  _validateEmail(email) {
    const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,8})+$/;
    return re.test(email.value);
  }

  _validatePhone(phone) {
    const re = /^[\d]{3}-[\d]{3}-[\d]{4}$/;
    return re.test(phone.value);
  }

  _checkRequiredFields() {
    let isValid = true
    let requiredFieldSelectors = 'textarea:required, input:required'
    let requiredFields = this.formTarget.querySelectorAll(requiredFieldSelectors)
    requiredFields.forEach((field) => {
      if (!field.disabled && !field.value.trim()) {
        field.classList.add('is-invalid-file');
        let missingField = document.getElementById(`${field.id}_required`);
        if (missingField) missingField.style.display = 'block';
        isValid = false;
      }
    });
    return isValid;
  }

  _checkValidFields() {
    let allValidFields = []
    let emailFields = this.formTarget.querySelectorAll('input[type="email"]')
    let phoneFields = this.formTarget.querySelectorAll('input[type="tel"]')
    emailFields.forEach((field) => {
      if(this._field_message(field, !this._validateEmail(field))) {
        allValidFields.push(false)
      }
    })
    phoneFields.forEach((field) => {
      if(this._field_message(field, !this._validatePhone(field))) {
        allValidFields.push(false)
      }
    })
    return allValidFields.every(Boolean);
  }

  _field_message(element, isNotValid){
    let invalidField = document.getElementById(`${element.id}_invalid`)
    if(!invalidField || element.value.length < 1) return

    invalidField.style.display = 'none'
    element.classList.remove('is-invalid-file')
    if (isNotValid) {
      element.classList.add('is-invalid-file')
      invalidField.style.display = 'block'
      return true
    }
  }
}
